import { request } from 'lib/api'
import { HTTP_METHODS } from 'lib/api/const'

class Referrals {
  static async getReferralCode({ customer_id }) {
    return request({
      url: `v6/referrals/referral-code`,
      methods: HTTP_METHODS.get,
      params: customer_id,
    })
  }

  static async getReferralOrders() {
    return request({
      url: `v6/referrals/orders`,
      methods: HTTP_METHODS.get,
    })
  }
}

export default Referrals
